export default __webpack_public_path__ + "static/media/shop2.8e5ea5aa.jpeg";